import React, { useState } from "react";
import { useKeenSlider } from "keen-slider/react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowLeft, ArrowRight } from "lucide-react";
import "keen-slider/keen-slider.min.css";

const leadershipData = [
    {
        id: 1,
        name: "Ajit Yadav",
        role: "Founder & CEO, Mobikode",
        image: "/assets/presence/img3.png",
        message: "At Mobikode, our journey began with a simple yet powerful belief: technology should not just support businesses, it should accelerate them. When I founded Mobikode in 2017, the vision was clear: to build a technology partner that delivers not only solutions, but measurable impact. Today, as digital transformation continues to redefine industries, our focus remains stronger than ever.",
        closing: "Let's build the future together."
    },
    {
        id: 2,
        name: "Ajit Yadav",
        role: "Project Manager, Mobikode",
        image: "/assets/presence/img3.png",
        message: "Delivering high-quality software architectures requires more than just clean code; it demands deep collaboration, strategic technical alignment, and a relentless focus on scalable solutions. We push the boundaries of frontend and backend design to ensure every deployment is auditable, resilient, and built for modern scalability.",
        closing: "Engineering excellence, consistently."
    }
];

const LeadershipMessage = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [sliderRef, instanceRef] = useKeenSlider({
        initial: 0,
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
        loop: true,
    });

    return (
        <section className="w-full bg-white py-12 sm:py-16 md:py-20 lg:py-24 text-left relative z-10 overflow-hidden">
            <div className="max-w-[1440px] mx-auto w-full px-5 sm:px-10 lg:px-[80px]">

                <div className="text-center mb-10 sm:mb-14 md:mb-16 w-full">
                    <h2 className="text-[20px] md:text-[30px] font-[600] font-sora text-[#01386A] leading-tight tracking-tight">
                        Message from leadership
                    </h2>
                </div>

                <div ref={sliderRef} className="keen-slider w-full">
                    {leadershipData.map((leader) => (
                        <div key={leader.id} className="keen-slider__slide">
                            <div className=" w-full flex flex-col md:flex-row items-stretch bg-white border border-[#E4E8F5] border-b-4 border-b-[#01386A] overflow-visible">
                                <div className="w-full md:w-full max-w-[417px] relative shrink-0 bg-slate-100">
                                    <img
                                        src={leader.image}
                                        alt={leader.name}
                                        className="absolute inset-0 w-full h-full object-cover object-center"
                                    />

                                    <div className="absolute left-0 bottom-[14px] md:bottom-[18px] md:left-1/2 -translate-x-1/2 bg-white p-5 md:p-6 shadow-xl border border-gray-100 min-w-[220px] sm:min-w-[260px] md:min-w-[287px] z-20 text-center">
                                        <h3 className="text-[20px] md:text-[30px] font-[600] font-sora text-[#01386A] leading-tight mb-1">
                                            {leader.name}
                                        </h3>
                                        <p className="text-[14px] md:text-[16px] text-[#49577A] font-[500] font-graphik">
                                            {leader.role}
                                        </p>
                                    </div>
                                </div>
                                <div className="w-full md:w-full max-w-[863px] p-6 sm:p-10 md:p-14 lg:p-16 flex flex-col justify-center items-start min-w-0 max-md:pt-12">
                                    <div className="relative w-full flex flex-col gap-5 sm:gap-6">
                                        <span className="text-[#01386A] text-[36px] sm:text-[44px] font-graphik leading-none absolute -left-1 -top-4 select-none">“</span>
                                        <p className="text-[14px] md:text-[16px] text-[#01386A] leading-relaxed font-[500] font-graphik break-words pl-4 pt-1">
                                            {leader.message}
                                        </p>

                                        <div className="flex flex-col gap-3 pl-4">
                                            <h4 className="text-[16px] md:text-[20px] font-[600] text-[#01386A] font-sora tracking-tight break-words">
                                                {leader.closing}
                                            </h4>
                                            <div className="flex flex-col text-[14px] sm:text-[16px] font-graphik font-[500] text-[#01386A]">
                                                <span className="font-[500]">Warm regards,</span>
                                                <span className="font-[500] text-[#01386A] mt-0.5">{leader.name}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="flex items-center gap-3 w-full justify-start px-1 mt-8 md:mt-12">
                    <button
                        onClick={() => instanceRef.current?.prev()}
                        className="w-10 h-10 rounded-full border border-[#ED6800] text-[#ED6800] flex items-center justify-center bg-transparent hover:bg-[#ED6800] hover:text-white transition-all duration-300 cursor-pointer outline-none select-none"
                        title="Previous leadership message"
                    >
                        <ArrowLeft size={18} />
                    </button>
                    <button
                        onClick={() => instanceRef.current?.next()}
                        className="w-10 h-10 rounded-full border border-[#ED6800] text-[#ED6800] flex items-center justify-center bg-transparent hover:bg-[#ED6800] hover:text-white transition-all duration-300 cursor-pointer outline-none select-none"
                        title="Next leadership message"
                    >
                        <ArrowRight size={18} />
                    </button>
                </div>

            </div>
        </section>
    );
};

export default LeadershipMessage;